/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PiePiece } from './PiePiece';
import {
    PiePieceFromJSON,
    PiePieceFromJSONTyped,
    PiePieceToJSON,
    PiePieceToJSONTyped,
} from './PiePiece';

/**
 * 
 * @export
 * @interface PieDataRepresentation
 */
export interface PieDataRepresentation {
    /**
     * 
     * @type {Array<PiePiece>}
     * @memberof PieDataRepresentation
     */
    data?: Array<PiePiece>;
}

/**
 * Check if a given object implements the PieDataRepresentation interface.
 */
export function instanceOfPieDataRepresentation(value: object): value is PieDataRepresentation {
    return true;
}

export function PieDataRepresentationFromJSON(json: any): PieDataRepresentation {
    return PieDataRepresentationFromJSONTyped(json, false);
}

export function PieDataRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PieDataRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(PiePieceFromJSON)),
    };
}

export function PieDataRepresentationToJSON(json: any): PieDataRepresentation {
    return PieDataRepresentationToJSONTyped(json, false);
}

export function PieDataRepresentationToJSONTyped(value?: PieDataRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(PiePieceToJSON)),
    };
}

